// extracted by mini-css-extract-plugin
export default {"APIConfigPage-config-blocks":"APIConfigPage-config-blockstQiivrNyelsM"};